import {AbstractGroup} from './abstract-group';
import {AbstractOptionData} from './types/abstract-option-data';
import {Logger} from './utilities/logger';
import mitt, {Emitter} from 'mitt';
import {A11yConsentApi} from './a11y-consent-api';

/**
 * Base for a consent option.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export abstract class AbstractOption {
  // Emits events related to the group
  public readonly emitter: Emitter<any> = mitt<any>();

  // A11y Consent API
  public readonly api: A11yConsentApi;

  // Parent group
  public readonly group: AbstractGroup;

  // UID
  public readonly uid: number;

  // Title
  public readonly title: string;

  // Description
  public readonly description: string;

  /**
   * @param {A11yConsentApi} api A11y Consent API
   * @param {AbstractGroup} group Parent group
   * @param {AbstractOptionData} data Option data from the global configuration object
   */
  protected constructor(api: A11yConsentApi, group: AbstractGroup, data: AbstractOptionData) {
    this.uid = data.uid;
    Logger.debug('abstract-option', `Starting to construct "${this.uid}".`);

    this.api = api;
    this.group = group;
    this.title = data.title;
    this.description = data.description;

    Logger.debug('abstract-option', `Finished constructing "${this.uid}".`);
  }
}
